import { useState } from 'react';
import { useKeyboardShortcut, useModalEscape } from '@/shared/services/KeyboardEventManager';

interface UseKeyboardShortcutsProps {
  hasSearchPermission?: boolean;
}

export const useKeyboardShortcuts = (props?: UseKeyboardShortcutsProps) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { hasSearchPermission = true } = props || {};

  // Register Ctrl+K for search (Windows/Linux)
  useKeyboardShortcut('k', () => {
    setIsSearchOpen(true);
  }, {
    modifiers: { ctrl: true },
    priority: 100, // High priority for global shortcuts
    preventDefault: true,
    enabled: hasSearchPermission,
    // i18n-raw-ui-literal-exempt: Keyboard-manager registration metadata, not rendered product UI.
    description: 'Open search panel (Ctrl+K)'
  });

  // Register Cmd+K for search (Mac)
  useKeyboardShortcut('k', () => {
    setIsSearchOpen(true);
  }, {
    modifiers: { cmd: true },
    priority: 100,
    preventDefault: true,
    enabled: hasSearchPermission,
    // i18n-raw-ui-literal-exempt: Keyboard-manager registration metadata, not rendered product UI.
    description: 'Open search panel (Cmd+K)'
  });

  // Register ESC to close search - now properly managed with modal stack
  useModalEscape('search-panel', () => setIsSearchOpen(false), {
    priority: 150, // Medium-high priority
    enabled: isSearchOpen
  });

  return { isSearchOpen, setIsSearchOpen };
}; 
